import { render, staticRenderFns } from "./MediaChannelsBlock.vue?vue&type=template&id=e51e7fca"
import script from "./MediaChannelsBlock.vue?vue&type=script&lang=js"
export * from "./MediaChannelsBlock.vue?vue&type=script&lang=js"
import style0 from "./MediaChannelsBlock.vue?vue&type=style&index=0&id=e51e7fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports